import VacationsView from '../VacationsView.vue'
import VacationRequestList from '../Pages/VacationRequestList.vue'
import VacationRequestCreate from '../Pages/VacationRequestCreate.vue'
import VacationRequestDetail from '../Pages/VacationRequestDetail.vue'
import VacationHistoricalCreate from '../Pages/VacationHistoricalCreate.vue'
import VacationBulkUploadPage from '../Pages/VacationBulkUploadPage.vue'
import VacationCalendar from '../Pages/VacationCalendar.vue'
import VacationHistory from '../Pages/VacationHistory.vue'
import VacationPeriodsList from '../Pages/VacationPeriodsList.vue'

const routes = [
  {
    path: '/vacaciones',
    component: VacationsView,
    children: [
      {
        path: 'solicitudes',
        name: 'vacation-requests-list',
        component: VacationRequestList,
      },
      {
        path: 'solicitudes/crear',
        name: 'vacation-requests-create',
        component: VacationRequestCreate,
      },
      {
        path: 'solicitudes/historico',
        name: 'vacation-requests-historical',
        component: VacationHistoricalCreate,
      },
      {
        path: 'carga',
        name: 'vacation-bulk-upload',
        component: VacationBulkUploadPage,
      },
      {
        path: 'solicitudes/:id',
        name: 'vacation-requests-detail',
        component: VacationRequestDetail,
      },
      {
        path: 'calendario',
        name: 'vacation-calendar',
        component: VacationCalendar,
      },
      {
        path: 'historial',
        name: 'vacation-history',
        component: VacationHistory,
      },
      {
        path: 'periodos',
        name: 'vacation-periods-list',
        component: VacationPeriodsList,
      },
    ]
  }
]

export default routes
